import { useContext } from "react";

import { CurrencyContext } from "../contexts/CurrencyContext";

const useCurrency = () => useContext(CurrencyContext);

export default useCurrency;
